import React, { forwardRef } from 'react';

import { reduceSystemProps } from 'src/system2';

export const Box = forwardRef(function Box({ as: El = 'div', sx, style, className, ...props }, ref) {
  return <El {...{ ...reduceSystemProps({ ...sx, style, className }), ...props, ref }} />;
});
